<h2 class="form-header">Pre-assessment Funding Request Treatments</h2>
<div class="info-banner">
  <mat-icon>info_outline</mat-icon>
  <div class="info-text">
    <h3>Notify GIS Specialist to Map Treatments (Optional)</h3>
    <span>The treatments from the pre-assessment request have been authorized and will count toward the regional
    authorization limit.</span>
    <span>Please notify the GIS specialist to map the treatments listed below into the GIS database for this
    report.</span>
    @if(gis_specialist()) {
      <span><b>Assigned GIS Specialist:</b> {{gis_specialist().user.full_name}}</span>
    } @else {
      <span><b>Assigned GIS Specialist:</b> <span style="font-style: italic;">Unassigned (Visit the <a
      [routerLink]="'/fire-overview'" [queryParams]="{assessment_id: report().assessment_id, tab: 1}">
    Teams</a> tab and
  assign a GIS Specialist for this report)</span></span>
}
</div>
<button class="btn-only" (click)="notify_gis_specialist()" [disabled]="!gis_specialist()"><span>Notify GIS
specialist</span>
<mat-icon>send</mat-icon></button>
</div>

@for (forest of report().forests; track forest) {
  <mat-card>
    <div class="title">{{forest.forest_name}}</div>
    <div class="text-subtitle">
      <b>RO Authorized Funding</b>
    </div>
    <div class="table-container">
      <table mat-table [dataSource]="forest.data ?? []" class="mat-elevation-z8">
        <!-- Treatment Column -->
        <ng-container matColumnDef="treatment">
          <th mat-header-cell *matHeaderCellDef>Treatment</th>
          <td mat-cell *matCellDef="let item" class="treatment-cell"
            [style.background-color]="item.select?.value ? '#FFF5E1' : ''" [ngClass]="item.rowType">
            {{item.treatment ?? "--"}}
          </td>
          <td mat-footer-cell *matFooterCellDef colspan="8"> Total Funds </td>
        </ng-container>
        <!-- Spec. # Column -->
        <ng-container matColumnDef="spec_number">
          <th mat-header-cell *matHeaderCellDef>Spec. #</th>
          <td mat-cell *matCellDef="let item" [ngClass]="item.rowType"
            [style.background-color]="item.select?.value ? '#FFF5E1' : ''">
            @if (item.rowType == "normal-cell") {
              {{item.specification_number}}
            }
          </td>
        </ng-container>
        <!-- Spec. Name Column -->
        <ng-container matColumnDef="spec_name">
          <th mat-header-cell *matHeaderCellDef>Spec. Name</th>
          <td mat-cell *matCellDef="let item" [ngClass]="item.rowType"
            [style.background-color]="item.select?.value ? '#FFF5E1' : ''">
            @if (item.rowType == "normal-cell") {
              {{item.specification_name ?? "--"}}
            }
          </td>
        </ng-container>
        <!-- Off-NFS Column -->
        <ng-container matColumnDef="off_nfs">
          <th mat-header-cell *matHeaderCellDef>Off-NFS</th>
          <td mat-cell *matCellDef="let item" [ngClass]="item.rowType"
            [style.background-color]="item.select?.value ? '#FFF5E1' : ''">
            @if (item.rowType == "normal-cell") {
              {{item.treatment_off_nfs_land ? "Yes": (item.treatment_off_nfs_land === null? "--":"No")}}
            }
          </td>
        </ng-container>
        <!-- Outside Fire Column -->
        <ng-container matColumnDef="outside_fire">
          <th mat-header-cell *matHeaderCellDef>Outside Fire</th>
          <td mat-cell *matCellDef="let item" [ngClass]="item.rowType"
            [style.background-color]="item.select?.value ? '#FFF5E1' : ''">
            @if (item.treatment == "P1b. Invasives EDRR - Suppression Repair") {
            N/A
            } @else if ((item.from_GIS !== false) && (item.treatment_outside_fire === null)) {
            Does Not Apply
            } @else {
            {{item.treatment_outside_fire ? "Yes": (item.treatment_outside_fire === null? "--":"No")}}
            }
          </td>
        </ng-container>
        <!-- Unit Type Column -->
        <ng-container matColumnDef="unit_type">
          <th mat-header-cell *matHeaderCellDef>Unit Type</th>
          <td mat-cell *matCellDef="let item" [ngClass]="item.rowType"
            [style.background-color]="item.select?.value ? '#FFF5E1' : ''">
            @if (item.rowType == "normal-cell") {
              {{item.unit_type ?? "--"}}
            }
          </td>
        </ng-container>
        <!-- num of units Column -->
        <ng-container matColumnDef="unit_qty">
          <th mat-header-cell *matHeaderCellDef style="text-align: end;"># of Units</th>
          <td mat-cell *matCellDef="let item" style="text-align: end;" [ngClass]="item.rowType+' '+item.qty_class"
            [style.background-color]="item.select?.value ? '#FFF5E1' : ''">
            @if (item.rowType != "bonus-top") {
              @if (item.rowType == "normal-cell") {
                {{item.unit_qty ?? "--"}}
              } @else if (item.rowType == "bonus-data") {
                {{item.approved_unit_qty ?? "--"}}
              } @else {
                {{item.wo_approved_unit_qty ?? "--"}}
              }
            }
          </td>
        </ng-container>
        <!-- Unit Cost Column -->
        <ng-container matColumnDef="unit_cost">
          <th mat-header-cell *matHeaderCellDef style="text-align: end;">Unit Cost</th>
          <td mat-cell *matCellDef="let item" style="text-align: end;" [ngClass]="item.rowType+' '+item.cost_class"
            [style.background-color]="item.select?.value ? '#FFF5E1' : ''">
            @if (item.rowType != "bonus-top") {
              @if (item.rowType == "normal-cell") {
                {{item.unit_cost | currency | empty_check}}
              } @else if (item.rowType == "bonus-data") {
                {{item.approved_unit_cost | currency | empty_check}}
              } @else {
                {{item.wo_approved_unit_cost | currency | empty_check}}
              }
            }
          </td>
        </ng-container>

        <!-- Cost Column -->
        <ng-container matColumnDef="total">
          <th mat-header-cell *matHeaderCellDef style="text-align: end;">Requested Total ($)</th>
          <td mat-cell *matCellDef="let item" style="text-align: end;" [ngClass]="item.rowType"
            [style.background-color]="item.select?.value ? '#FFF5E1' : ''">
            @if (item.hideRequested != true && item.rowType != "bonus-top" && item.rowType == "normal-cell") {
              {{unitTotal(item, true) | currency | empty_check}}
            }
          </td>
          <td mat-footer-cell *matFooterCellDef style="text-align: end;"> {{forestTotal(forest.data) | currency |
          empty_check}} </td>
        </ng-container>


        <!-- Authorized Total Column -->
        <ng-container matColumnDef="authorized_total">
          <th mat-header-cell *matHeaderCellDef style="text-align: end;">Authorized Total ($)</th>
          <td mat-cell *matCellDef="let item" style="text-align: end;" class="green-cell" [ngClass]="item.rowType"
            [style.background-color]="item.select?.value ? '#FFF5E1' : ''">
            @if (item.rowType != "bonus-top") {
              @if (item.rowType == "normal-cell") {
                {{(item.approved_unit_qty * item.approved_unit_cost) | currency | empty_check }}
              } @else if (item.rowType == "bonus-data") {
                {{(item.approved_unit_qty * item.approved_unit_cost) | currency | empty_check }}
              } @else {
                {{(item.wo_approved_unit_qty * item.wo_approved_unit_cost) | currency | empty_check }}
              }
            }
          </td>
          <td mat-footer-cell *matFooterCellDef style="text-align: end;" class="green-footer">
          {{forestTotalAuthorized(forest.data) | currency}} </td>
        </ng-container>
        <!-- Authorized By Column -->
        <ng-container matColumnDef="authorized_by">
          <th mat-header-cell *matHeaderCellDef>Authorized By</th>
          <td mat-cell *matCellDef="let item" [ngClass]="item.rowType"
            [style.background-color]="item.select?.value ? '#FFF5E1' : ''">
            {{ item.ro_authorized_by_id | authorizationMethod }}
          </td>
          <td mat-footer-cell *matFooterCellDef colspan="3"></td>
        </ng-container>
        <!-- Authorized Status Column -->
        <ng-container matColumnDef="authorized_status">
          <th mat-header-cell *matHeaderCellDef>Authorization Status/Note</th>
          <td mat-cell *matCellDef="let item" class="note-text" [matTooltip]="tooltip(item)" [ngClass]="item.rowType"
            [style.background-color]="item.select?.value ? '#FFF5E1' : ''">
            <div class="note-div">
              @for (id of item.authorization_status_ids; track id) {
                <div>
                  {{getAuthStatusText(id)}}
                </div>
              }

              <div>
                @if (item.rowType == "normal-cell") {
                  {{ item.authorization_note }}
                }
              </div>
            </div>
          </td>
        </ng-container>
        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
        <tr mat-footer-row *matFooterRowDef="footerDisplayedColumns" [hidden]="forest.data?.length == 0"></tr>

        <!-- Row shown when there is no matching data. -->
        <tr class="mat-row" *matNoDataRow>
          <td class="mat-cell" colspan="14">
            <div class="no-data">
              <div class="no-data-icon">
                <mat-icon class="no-data-icon1">search</mat-icon>
                <mat-icon class="no-data-icon2">attach_money</mat-icon>
              </div>
              <div class="no-data-title">Requested Funds Unavailable</div>
              <p style="max-width: 370px; text-align: center;">No treatment funds have been requested yet in the
              Recommended Treatment Narratives section</p>
            </div>
          </td>
        </tr>
      </table>
    </div>
  </mat-card>
}